import {Label} from "semantic-ui-react";
import {formatCurrency} from "../../utils/commonutils";
import React from "react";

const SummaryCodeAmountChips = ({data, title, name, value, selectedCode, onCodeClick}) => {
    const obj = data.reduce((acc, curr) => {
        acc[curr[name]] = (acc[curr[name]] ?? 0) + (curr[value] ?? 0);
        return acc;
    }, {});

    const isClickable = typeof onCodeClick === 'function';

    const chips = Object.entries(obj)
        .sort((a, b) => b[1] - a[1])
        .map(([code, amount], i) => {
            const isSelected = selectedCode === code;
            const label = (
                <Label
                    style={{fontSize: '14px', cursor: isClickable ? 'pointer' : 'default'}}
                    basic={!isSelected}
                    color={Number(amount) > 0 ? "green" : "blue"}
                    detail={formatCurrency(amount)}
                    content={code}
                    onClick={isClickable ? () => onCodeClick(isSelected ? null : code) : undefined}
                />
            );
            if (!isSelected) return <React.Fragment key={i}>{label}</React.Fragment>;
            return (
                <span key={i} style={{position: 'relative', display: 'inline-block'}}>
                    {label}
                    <span
                        onClick={(e) => { e.stopPropagation(); onCodeClick(null); }}
                        style={{
                            position: 'absolute',
                            top: '-7px',
                            right: '-7px',
                            width: '18px',
                            height: '18px',
                            borderRadius: '50%',
                            background: '#fff',
                            border: '1px solid #999',
                            color: '#333',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            fontSize: '12px',
                            lineHeight: 1,
                            fontWeight: 'bold',
                            zIndex: 1,
                        }}
                    >
                        ×
                    </span>
                </span>
            );
        });
    return <>
        <p><b>{title}</b></p>
        {chips}
    </>;
}


export default SummaryCodeAmountChips